var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "left-sidebar" }, [
    _c("div", { staticClass: "scroll-sidebar" }, [
      _c("nav", { staticClass: "sidebar-nav" }, [
        _c(
          "ul",
          { attrs: { id: "sidebarnav" } },
          [
            _vm.connectedToUserApp
              ? _c(
                  "li",
                  { staticClass: "sidebar-item" },
                  [
                    _c(
                      "b-link",
                      {
                        staticClass:
                          "sidebar-link waves-effect waves-dark sidebar-link",
                        attrs: { href: _vm.user_app_url },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("b-icon", {
                              staticClass: "icon-menu",
                              attrs: { icon: "phone" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { staticClass: "hide-menu" }, [
                            _vm._v("Go To User App"),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.visibleMenuItems, function (item, index) {
              return _c(
                "li",
                { key: index, staticClass: "sidebar-item" },
                [
                  _c(
                    "b-link",
                    {
                      staticClass:
                        "sidebar-link waves-effect waves-dark sidebar-link",
                      attrs: { to: { name: item.route } },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("b-icon", {
                            staticClass: "icon-menu",
                            attrs: { icon: item.icon },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "hide-menu" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  item.children
                    ? _c(
                        "ul",
                        { staticClass: "sidebar-item-submenu" },
                        _vm._l(item.children, function (childItem, childIndex) {
                          return _c(
                            "li",
                            { key: childIndex, staticClass: "sidebar-item" },
                            [
                              _c(
                                "b-link",
                                {
                                  staticClass:
                                    "sidebar-link waves-effect waves-dark sidebar-link",
                                  attrs: { to: { name: childItem.route } },
                                },
                                [_c("span", [_vm._v(_vm._s(childItem.title))])]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }